<template>
  <v-toolbar :color="ui.cardColor">
    <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
    <v-toolbar-title>
      <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
        <v-avatar>
        <v-icon> edit </v-icon>
        </v-avatar>
        Open
      </v-chip>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
    class="hidden-md-and-down">
      <v-avatar>
      <v-icon> savings </v-icon>
      </v-avatar>
      {{stats.nb4o}}
    </v-chip>
    <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
    class="hidden-md-and-down">
      <v-avatar>
      <v-icon> shopping_bag </v-icon>
      </v-avatar>
      {{stats.nq1o}}
    </v-chip>
    <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
    class="hidden-md-and-down">
      <v-avatar>
      <v-icon> settings </v-icon>
      </v-avatar>
      {{stats.ne2o}}
    </v-chip>
    <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
      <v-avatar>
      <v-icon> today </v-icon>
      </v-avatar>
      {{stats.nb6o}}
    </v-chip>
    <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
    class="hidden-sm-and-down">
      <v-avatar>
      <v-icon> report </v-icon>
      </v-avatar>
      {{stats.ns6o}}
    </v-chip>
    <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
      <v-avatar>
      <v-icon> task </v-icon>
      </v-avatar>
      {{stats.nb3o}}
    </v-chip>
    <StatsReadCardOpen :data="{tag: 'C1'}"/>
  </v-toolbar>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import StatsReadCardOpen from "@/support/stats/components/StatsReadCardOpen";
import { mapGetters } from "vuex";

export default {
  props: {
    data: {
      type: Object
    }
  },
  components: {
    StatsReadCardOpen
  },
  computed: {
    ...mapGetters(["getDetailStats"]),
    stats() {
      return this.getDetailStats;
    }
  },
  mixins: [apptheme, licenceFunctions, adminFunctions],
  data() {
    return {
      valid: true
    };
  }
};
</script>
